import { render } from "./input-form.vue?vue&type=template&id=6518a338"
import script from "./input-form.vue?vue&type=script&lang=js"
export * from "./input-form.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__